exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--person__3UqLa{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.styles--personFields__1j47W{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.styles--personCounter__1sRFL{margin-bottom:5px;margin-right:5px}.styles--personInput__1nVQF{margin-bottom:5px}.styles--fieldError__fB4ze{color:#ff5722;margin-bottom:6px}\n", ""]);

// exports
exports.locals = {
	"person": "styles--person__3UqLa",
	"personFields": "styles--personFields__1j47W",
	"personCounter": "styles--personCounter__1sRFL",
	"personInput": "styles--personInput__1nVQF",
	"fieldError": "styles--fieldError__fB4ze"
};